module.exports = __webpack_public_path__ + "img/qrcode_kf.ab0f2940.jpg";